// extracted by mini-css-extract-plugin
export default {"auth_form":"hb9ilS","auth_form__info":"OTGGpf","auth_form__info__alert":"NkqxqC","auth_form__info__alert__message":"c2N5Uh","auth_form__button":"LNgtgc"};